export enum JourneyMenuTab {
	MY_JOURNEY = 'myJourney',
	TOOLBOX = 'toolbox',
}
